import en from "./en.json";
import ja from "./ja.json";
import kr from "./kr.json";

export const inboxLocales = { en, ja, kr };
